import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app/store";

interface CustomerState {
  data: {} | any | null;
  totalPage: number | null;
}

const initialState: CustomerState = {
  data: null,
  totalPage:null,
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomer: (state,action) => {
      state.data = action.payload;
      state.totalPage = action.payload.totalPage;

    },
    resetCustomer: (state) => {
      state.data = null;
      state.totalPage=null;
    },
  },
});

export const { setCustomer, resetCustomer } = customerSlice.actions;

export const selectCustomerData = (state: RootState) => state.customer.data;
export const selectCustomerPage = (state: RootState) => state.customer.totalPage;

export default customerSlice.reducer;
